export default __webpack_public_path__ + "static/2019_15-4021018edef9884df07b518c2f1e1bb6.png";